import type { Ctx } from "../../types";
import { Action, invalidate, removeQueryParams } from "gg-wf-scripts";
import { toast } from "../../toast";

export const delete_user: Action<Ctx> = async ({ sb }, _data, params) => {
  const user_id = params.get("id");
  if (!user_id) return { ok: false, error: "Missing id in URL" };

  const { error } = await sb.functions.invoke(`api/users/${user_id}`, {
    method: "DELETE",
  });
  if (error) {
    toast({ variant: "error", text: "User delete failed. Try again" });
    return { ok: false, error: error.message };
  }
  invalidate("users", "jobs");
  removeQueryParams(["modal", "id"]);
  toast({ variant: "success", text: "User deleted!" });
  return { ok: true };
};
